import { createContext, type ReactNode, useContext } from "react";
const ListboxSurfaceContext = createContext(false);
export const ListboxSurfaceProvider = ({
  children,
  usesSheet
}: {
  children: ReactNode;
  usesSheet: boolean;
}) => <ListboxSurfaceContext.Provider value={usesSheet} data-sentry-element="ListboxSurfaceContext.Provider" data-sentry-component="ListboxSurfaceProvider" data-sentry-source-file="ListboxSurfaceContext.tsx">
    {children}
  </ListboxSurfaceContext.Provider>;
export const useListboxUsesSheet = () => useContext(ListboxSurfaceContext);